import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const CustomerProfile = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      navigate("/log-in"); // redirect if not logged in
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
    navigate("/log-in");
  };

  if (!user) {
    return null; // while loading
  }

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 py-10 px-4">
      <div className="max-w-2xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-center text-blue-600 mb-6">
          Customer Panel
        </h1>

        {/* User Info */}
        <div className="space-y-4 text-gray-700 dark:text-gray-200">
          <p>
            <span className="font-semibold">Name: </span>
            {user.f_name} {user.l_name}
          </p>
          <p>
            <span className="font-semibold">Email: </span>
            {user.email}
          </p>
          <p>
            <span className="font-semibold">Phone: </span>
            {user.phone}
          </p>
          <p>
            <span className="font-semibold">Joined On: </span>
            {new Date(user.created_at).toLocaleDateString()}
          </p>
        </div>

        {/* Logout */}
        <div className="mt-8 text-center">
          <button
            onClick={handleLogout}
            className="px-6 py-2 rounded-lg bg-red-600 text-white font-medium hover:bg-red-700 transition"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerProfile;
